import { DemoIndicatorColoredIcon } from '@carboncopyco/icons';
import {
  Checkbox,
  TextBase,
  TooltipBubble,
  UserBasicInfo,
} from '@carboncopyco/ui';
import { MMMDoYYYY } from '@carboncopyco/utils';
import type { Col } from '../../FixedTable';
import { AssetLocationBreadcrumbs } from '../../PlaybookModal';
import type { TableItem } from '../types';

export const cols: Col<TableItem>[] = [
  {
    alignment: 'left',
    title: '',
    width: 40,
    render: (item) => {
      return (
        <div className="flex items-center">
          <Checkbox
            checked={item.selected}
            name={item.id.toString()}
            onChange={() => undefined}
          />
        </div>
      );
    },
  },
  {
    alignment: 'left',
    title: 'Asset name',
    width: 208,
    maxContentWidth: 188,
    render: ({ demoName }) => (
      <div className="flex items-center gap-2.5">
        <TooltipBubble
          title="Demo"
          placement="top"
        >
          <div className="shrink-0">
            <DemoIndicatorColoredIcon />
          </div>
        </TooltipBubble>
        <TooltipBubble
          placement="top"
          title={demoName}
        >
          <div className="truncate max-w-[160px]">
            <TextBase
              label={demoName}
              color="text-ds-natural-600"
            />
          </div>
        </TooltipBubble>
      </div>
    ),
  },
  {
    alignment: 'left',
    title: 'Created by',
    width: 172,
    maxContentWidth: 155,
    render: (item) => (
      <UserBasicInfo
        size="small"
        user={item?.creator}
        textColor="text-ds-natural-600"
        truncateWidth={130}
        tooltip
      />
    ),
  },
  {
    alignment: 'left',
    title: 'Last edited',
    width: 140,
    render: (item) => (
      <TooltipBubble
        title={MMMDoYYYY(item.updateTime)}
        placement="top-start"
      >
        <TextBase label={MMMDoYYYY(item.updateTime)} />
      </TooltipBubble>
    ),
  },
  {
    alignment: 'left',
    title: 'Location',
    width: 192,
    maxContentWidth: 192,
    render: (item) => {
      const isInRoot = item.folderId === '0';
      return isInRoot ? null : (
        <AssetLocationBreadcrumbs
          workspaceId={item.workspaceId}
          organizationId={item.organizationId}
          location={{
            id: isInRoot ? item.workspaceId : String(item.folderId),
            entity: isInRoot ? 'workspace' : 'folder',
          }}
        />
      );
    },
  },
];
